import axios from 'axios';
import { microServicesURLs } from './axios';

// Response shape: { version, minimumClientVersion, feVersion }
// `feVersion` is the latest FE build version pushed to the backend by the
// deploy pipeline (see scripts/notify-deploy.js and RELEASE_SOP.md).
export const getVersionAPI = async () => {
  const response = await axios.get(`${microServicesURLs.DE_CORE}/version`, {
    withCredentials: true,
    headers: { 'x-client-type': 'web' }
  });
  return response.data;
};
